import Button from "components/Button"

export const EditorForm = ({resetView})=> {
  return <div className="editor-form">
    <h3>Wish to continue editing previous article in editor?</h3>
    <Button isBlue={true} className="editor-form__button" tool={'Beast Mode'} onClick={()=>{resetView(true)}}>Yes, navigate to editor</Button>
    <Button className="editor-form__button" tool={'Beast Mode'} onClick={()=>{resetView(false)}}>No, generate a new article</Button>
  </div>
} 